import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { UsersService } from "src/app/_services/admin/users.service";
import { AuthenticationService } from "src/app/auth/authentication.service";
import { ReportService } from "../../../_services/report.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { emailPatternValidator } from "../../../_utilities/custom.validators";
import moment from "moment-timezone";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";
import { Subscription } from "rxjs";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { DeleteRecordService } from "src/app/_services/delete-record.service";

@Component({
    selector: 'app-report-schedule-export',
    templateUrl: './report-schedule-export.component.html',
    styleUrls: ['./report-schedule-export.component.scss'],
    standalone: false
})
export class ReportScheduleExportComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  scheduleConfigForm: FormGroup;
  frequencyList: any = [
    {
      name: "Daily",
      value: "DAILY",
    },
    {
      name: "Weekly",
      value: "WEEKLY",
    },
    {
      name: "Monthly",
      value: "MONTHLY",
    },
  ];
  timeList: any[] = [
    { name: "7:00am", value: "07:00:00" },
    { name: "9:00am", value: "09:00:00" },
    { name: "12:00pm", value: "12:00:00" },
    { name: "5:00pm", value: "17:00:00" },
  ];
  dayList: any[] = [
    { name: "Monday", value: "MON" },
    { name: "Tuesday", value: "TUE" },
    { name: "Wednesday", value: "WED" },
    { name: "Thursday", value: "THU" },
    { name: "Friday", value: "FRI" },
    { name: "Saturday", value: "SAT" },
    { name: "Sunday", value: "SUN" },
  ];
  dayOfMonthList: any[] = [
    { name: "First", value: "FIRST" },
    { name: "Second", value: "SECOND" },
    { name: "Third", value: "THIRD" },
    { name: "Fourth", value: "FOURTH" },
    { name: "Last", value: "LAST" },
  ];
  users: any = [];
  user_groups: any = [];
  data: any;
  isSubmitClicked: boolean = false;
  minDate: Date;
  minDateStart: Date;
  isScheduleFound: boolean = false;
  scheduleInfo: any;
  deleteSubscription!: Subscription;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private userService: UsersService,
    private auth: AuthenticationService,
    private reportServc: ReportService,
    private errorUtil: ErrorUtil,
    private util: UtilServiceService,
    private deleteRecordServc: DeleteRecordService, private bsModalServc: BsModalService
  ) {
    super();
    this.scheduleConfigForm = new FormGroup({
      fileType: new FormControl(""),
      scheduleStartDate: new FormControl("", [Validators.required]),
      scheduleEndDate: new FormControl(""),
      isScheduleNeverEnd: new FormControl(false),
      frequency: new FormControl(null, [Validators.required]),
      day: new FormControl(null),
      time: new FormControl(null),
      recipientsUser: new FormControl([], [Validators.required]),
      recipientsGroup: new FormControl([], [Validators.required]),
      otherRecipients: new FormControl([], [emailPatternValidator(), Validators.required]),
      dayOfMonth: new FormControl(null),
      dayMonth: new FormControl(null),
    });
  }

  ngOnInit(): void {
    this.minDateStart = new Date();
    this.minDateStart.setDate(this.minDateStart.getDate());
    this.languageTranslateService.wordSrc$.subscribe((data) => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
        this.getUsersList();
        this.getGroupList();
        if (this.data.mode == "edit") {
          this.getScheduleInfo();
        }
      }
    });
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onFrequencyChange(e: any) {
    if (e.value == "DAILY") {
      this.scheduleConfigForm.controls["time"].reset();
      this.scheduleConfigForm.controls["time"].setValidators([
        Validators.required,
      ]);

      this.scheduleConfigForm.controls["day"].clearValidators();
      this.scheduleConfigForm.controls["dayOfMonth"].clearValidators();
      this.scheduleConfigForm.controls["dayMonth"].clearValidators();

      this.scheduleConfigForm.controls["day"].updateValueAndValidity();
      this.scheduleConfigForm.controls["dayOfMonth"].updateValueAndValidity();
      this.scheduleConfigForm.controls["dayMonth"].updateValueAndValidity();
      this.scheduleConfigForm.controls["time"].updateValueAndValidity();
    } else if (e.value == "WEEKLY") {
      this.scheduleConfigForm.controls["day"].reset();
      this.scheduleConfigForm.controls["time"].reset();

      this.scheduleConfigForm.controls["time"].setValidators([
        Validators.required,
      ]);
      this.scheduleConfigForm.controls["day"].setValidators([
        Validators.required,
      ]);

      this.scheduleConfigForm.controls["dayOfMonth"].clearValidators();
      this.scheduleConfigForm.controls["dayMonth"].clearValidators();
      this.scheduleConfigForm.controls["dayOfMonth"].updateValueAndValidity();
      this.scheduleConfigForm.controls["dayMonth"].updateValueAndValidity();

      this.scheduleConfigForm.controls["time"].updateValueAndValidity();
      this.scheduleConfigForm.controls["day"].updateValueAndValidity();
    } else {
      //dayOfMonth
      this.scheduleConfigForm.controls["dayOfMonth"].reset();
      this.scheduleConfigForm.controls["dayMonth"].reset();

      this.scheduleConfigForm.controls["dayOfMonth"].setValidators([
        Validators.required,
      ]);
      this.scheduleConfigForm.controls["dayMonth"].setValidators([
        Validators.required,
      ]);

      this.scheduleConfigForm.controls["time"].reset();
      this.scheduleConfigForm.controls["time"].setValidators([
        Validators.required,
      ]);

      this.scheduleConfigForm.controls["day"].clearValidators();
      this.scheduleConfigForm.controls["day"].updateValueAndValidity();
      this.scheduleConfigForm.controls["dayOfMonth"].updateValueAndValidity();
      this.scheduleConfigForm.controls["dayMonth"].updateValueAndValidity();
      this.scheduleConfigForm.controls["time"].updateValueAndValidity();
    }
  }

  getUsersList() {
    this.userService.getActiveUsers().subscribe((data: any) => {
      this.users = data;
      //logged in user should not be in the user list of sharing option
      this.users = this.users.filter(
        (user: any) => user.id !== parseInt(this.auth.getUserId())
      );
    });
  }

  getGroupList() {
    this.userService.getAlluserGroup().subscribe((data: any) => {
      this.user_groups = data;
    });
  }

  onFormSubmit() {
    this.isSubmitClicked = true;
    if (this.scheduleConfigForm.valid) {

      let startDateMoment = moment(
        this.scheduleConfigForm.get("scheduleStartDate").value
      );

      let startDate: any = moment(
        this.scheduleConfigForm.get("scheduleStartDate").value
      ).format("YYYY-MM-DD");

      let startDateISO: any = startDateMoment.startOf('day').toISOString();//12:00 am time of selected date

      let todayDate: any = new Date().getDate();//today value
      let selectedInputDate: any = startDateMoment.toDate().getDate();

      //if selected date is today, set the time to more than current time. Not 12:00am time
      if (selectedInputDate == todayDate){
        startDateISO = startDateMoment.toISOString();
      }

      let endDate: any;
      let endDateISO: any = null;

      if (this.scheduleConfigForm.get("scheduleEndDate").value) {
        endDate = moment(
          this.scheduleConfigForm.get("scheduleEndDate").value
        ).format("YYYY-MM-DD");

        //11:59pm time of selected date
        endDateISO = moment( this.scheduleConfigForm.get("scheduleEndDate").value ).endOf('day').toISOString();
      }

      let users: any = this.scheduleConfigForm.get("recipientsUser").value;
      let groups: any = this.scheduleConfigForm.get("recipientsGroup").value;
      let time: any = this.scheduleConfigForm.get("time").value;
      let day: any = this.scheduleConfigForm.get("day").value;
      let weekPosition: any = this.scheduleConfigForm.get("dayOfMonth").value;
      let weekDayOfMonth: any = this.scheduleConfigForm.get("dayMonth").value;

      let selectedUsers: any = users?.map((user: any) => {
        return { id: user };
      });

      let selectedGroups: any = groups?.map((g: any) => {
        return { id: g };
      });

      let frequency: any = this.scheduleConfigForm.get("frequency").value;
      if (frequency == "MONTHLY") {
        day = null;
      }
      if (frequency == "DAILY") {
        day = null;
        weekPosition = null;
        weekDayOfMonth = null;
      }
      if (frequency == "WEEKLY") {
        weekPosition = null;
        weekDayOfMonth = null;
      }

      let payload: any = {
        reportId: this.data.id,
        fileType: this.scheduleConfigForm.get("fileType").value,
        startDate: startDateISO,
        endDate: endDateISO,
        neverExpires: this.scheduleConfigForm.get("isScheduleNeverEnd").value,
        frequency: frequency,
        timeOfDay: time,
        dayOfWeek: day,
        weekPosition: weekPosition,
        weekDayOfMonth: weekDayOfMonth,
        users: users ? selectedUsers : [],
        userGroups: groups ? selectedGroups : [],
        externalEmails: this.scheduleConfigForm.get("otherRecipients").value,
      };

      if (!this.scheduleConfigForm.get("fileType").value) {
        return;
      }

     if (!this.isScheduleFound) {
        //if no schedule is found, create one. Otherwise, update.
        this.reportServc.createReportSchedule(payload).subscribe(
          (res: any) => {
            if (res.status == 200) {
              this.errorUtil.setErrorMessage(
                200,
                 this.translate?.report.sections.sec11.singular + ' '+ this.translate?.report.validationFE.hasBeenAddedToThe + ' ' +this.translate?.report.label.singular + ' ' + this.translate?.report.validationFE.successfully +".",
                null,
                "success",
                2000
              );
              this.bsModalServc.setDismissReason('addScheduleSuccess');
              this.modalRef.hide();
            }
          },
          (err: any) => {
            console.log(err, "error creating report schedule");
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000
            );
          }
        );
      } else {
        //update schedule
        payload["id"] = this.scheduleInfo.id;
        this.reportServc.updateReportSchedule(payload).subscribe(
          (res: any) => {
            if (res.status == 200) {
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.report.sections.sec11.singular + ' '+ this.translate?.report.validationFE.updatedSuccessfully,
                null,
                "success",
                2000
              );

              this.bsModalServc.setDismissReason('updateScheduleSuccess');
              this.modalRef.hide();
            }
          },
          (err: any) => {
            console.log(err, "error updating report schedule");
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000
            );
          }
        );
      }
    }
  }

  onUsersChange() {
    let formValue: any = this.scheduleConfigForm.get("recipientsUser").value;
    if (formValue.length > 3) {
      formValue.pop(); // remove last selected item
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate?.report.validationFE.maximumUserSelectionExceeded,
        "warn",
        2000
      );
      return;
    } else {
      //check if user length is 0
      if (formValue.length == 0) {
        //set validator to group because either one is required.
        this.scheduleConfigForm.controls["recipientsGroup"].setValidators([
          Validators.required,
        ]);
        this.scheduleConfigForm.controls[
          "recipientsGroup"
        ].updateValueAndValidity();
        this.scheduleConfigForm.controls["recipientsGroup"].markAsTouched();
        //set validator for exter emails too
        this.scheduleConfigForm.controls["otherRecipients"].setValidators([
          Validators.required,
        ]);
        this.scheduleConfigForm.controls[
          "otherRecipients"
        ].updateValueAndValidity();
        this.scheduleConfigForm.controls["otherRecipients"].markAsTouched();
        
      } else {
        //remove the validator
        this.scheduleConfigForm.controls["recipientsGroup"].clearValidators();
        this.scheduleConfigForm.controls[
          "recipientsGroup"
        ].updateValueAndValidity();

         this.scheduleConfigForm.controls["otherRecipients"].clearValidators();
        this.scheduleConfigForm.controls[
          "otherRecipients"
        ].updateValueAndValidity();
      }
    }
  }

  onGroupChange() {
    let formValue: any = this.scheduleConfigForm.get("recipientsGroup").value;
    if (formValue.length > 3) {
      formValue.pop(); // remove last selected item
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate?.report.validationFE.maximumGroupSelectionExceeded,
        "warn",
        2000
      );
      return;
    } else {
      //check if group length is 0
      if (formValue.length == 0) {
        //set validator to user because either one is required
        this.scheduleConfigForm.controls["recipientsUser"].setValidators([
          Validators.required,
        ]);
        this.scheduleConfigForm.controls[
          "recipientsUser"
        ].updateValueAndValidity();
        this.scheduleConfigForm.controls["recipientsUser"].markAsTouched();
         //set validator for external emails too
        this.scheduleConfigForm.controls["otherRecipients"].setValidators([
          Validators.required,
        ]);
        this.scheduleConfigForm.controls[
          "otherRecipients"
        ].updateValueAndValidity();
        this.scheduleConfigForm.controls["otherRecipients"].markAsTouched();

      } else {
        //remove the validator
        this.scheduleConfigForm.controls["recipientsUser"].clearValidators();
        this.scheduleConfigForm.controls[
          "recipientsUser"
        ].updateValueAndValidity();

        this.scheduleConfigForm.controls["otherRecipients"].clearValidators();
        this.scheduleConfigForm.controls[
          "otherRecipients"
        ].updateValueAndValidity();
      }
    }
  }

  onStartDateSelect() {
    let startDateVal: any =
      this.scheduleConfigForm.get("scheduleStartDate").value;
    this.minDate = new Date(startDateVal);
    this.minDate.setDate(this.minDate.getDate() + 1);
  }

  onEmailAdd() {
    let emailList: any = this.scheduleConfigForm.get("otherRecipients").value;
    if (emailList.length > 3) {
      emailList.pop();
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate?.report.validationFE.maximumEmailsExceeded,
        "warn",
        2000
      );
      return;
    }
    else{
      //check if emails length is 0
      if (emailList.length == 0) {
        //set validator to user because either one of 3 is required
        this.scheduleConfigForm.controls["recipientsUser"].setValidators([
          Validators.required,
        ]);
        this.scheduleConfigForm.controls[
          "recipientsUser"
        ].updateValueAndValidity();
        this.scheduleConfigForm.controls["recipientsUser"].markAsTouched();
         //set validator to user group 
        this.scheduleConfigForm.controls["recipientsGroup"].setValidators([
          Validators.required,
        ]);
        this.scheduleConfigForm.controls[
          "recipientsGroup"
        ].updateValueAndValidity();
        this.scheduleConfigForm.controls["recipientsGroup"].markAsTouched();

      } else {
        //remove the validator
        this.scheduleConfigForm.controls["recipientsUser"].clearValidators();
        this.scheduleConfigForm.controls[
          "recipientsUser"
        ].updateValueAndValidity();

        this.scheduleConfigForm.controls["recipientsGroup"].clearValidators();
        this.scheduleConfigForm.controls[
          "recipientsGroup"
        ].updateValueAndValidity();
      }
    }
  }

  onEndDateSelect() {
    let endDatVal: any = this.scheduleConfigForm.get("scheduleEndDate").value;
    if (endDatVal) {
      this.scheduleConfigForm.controls["isScheduleNeverEnd"].reset();
      this.scheduleConfigForm.controls["isScheduleNeverEnd"].disable();
    } else {
      this.scheduleConfigForm.controls["isScheduleNeverEnd"].enable();
    }
  }

  getScheduleInfo() {
    //data.id is schedule ID
    this.reportServc.getScheduleByID(this.data.id).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.scheduleInfo = res.body;
          if (this.scheduleInfo.length == 0) {
            this.isScheduleFound = false;
          } else {
            this.isScheduleFound = true;
            if (this.data.mode == "edit") {
              this.loadFormData();
            }
          }
        }
      },
      (err: any) => {
        console.log(err, "error gettting schedule by report id");
        if (err.error.detail == "scheduleNotFound") {
          this.isScheduleFound = false;
        }
      }
    );
  }

  loadFormData() {
    let userList: any = this.scheduleInfo.users?.map((user: any) => {
      return user.id;
    });
    let groupList: any = this.scheduleInfo.userGroups?.map((g: any) => {
      return g.id;
    });

    //2026-01-15T00:00:00Z
    let formValueEndDate: any = null;
    if (this.scheduleInfo.endDate) {
      let formatEndDate: any = this.scheduleInfo.endDate?.split("T");
      formValueEndDate = new Date(formatEndDate[0] + "T00:00:00Z");
    }

    this.scheduleConfigForm.patchValue({
      fileType: this.scheduleInfo.fileType,
      scheduleStartDate: new Date(this.scheduleInfo.startDate),
      scheduleEndDate: formValueEndDate,
      isScheduleNeverEnd: this.scheduleInfo.neverExpires,
      frequency: this.scheduleInfo.frequency,
      day: this.scheduleInfo.dayOfWeek,
      time: this.scheduleInfo.timeOfDay,
      recipientsUser: userList,
      recipientsGroup: groupList,
      otherRecipients: this.scheduleInfo.externalEmails,
      dayOfMonth: this.scheduleInfo.weekPosition,
      dayMonth: this.scheduleInfo.weekDayOfMonth,
    });

    //to apply date selection rules
    this.onStartDateSelect();
    //to clear/add form validations
    if (userList?.length > 0) {
      this.onUsersChange();
    }
    if (groupList?.length > 0) {
      this.onGroupChange();
    }
    if (this.scheduleInfo.externalEmails?.length){
      this.onEmailAdd();
    }
    this.onNeverCheckboxChange();//to enable/disable the end date based on Never field
    this.onEndDateSelect();
  }

  onNeverCheckboxChange(){
    if (this.scheduleConfigForm.get('isScheduleNeverEnd').value === true){
      //disable end date
      this.scheduleConfigForm.controls['scheduleEndDate'].disable();
      this.scheduleConfigForm.controls["scheduleEndDate"].updateValueAndValidity();
    }
    else{
      this.scheduleConfigForm.controls['scheduleEndDate'].enable();
      this.scheduleConfigForm.controls["scheduleEndDate"].updateValueAndValidity();
    }
  }
}
